import { TextField, type TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

export type ConditionTextFieldProps = Omit<
  TextFieldProps,
  'value' | 'onChange' | 'variant'
> & {
  value: string | number | null | undefined;
  onChange: (value: string) => void;
};

/**
 * A condition's text or number value. It leaves `variant` to the theme, so under the v2 theme
 * it is the same field box as the pickers beside it.
 */
export const ConditionTextField = forwardRef<HTMLDivElement, ConditionTextFieldProps>(
  ({ value, onChange, placeholder = 'Value', fullWidth = true, ...rest }, ref) => (
    <TextField
      ref={ref}
      size="small"
      fullWidth={fullWidth}
      placeholder={placeholder}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value)}
      {...rest}
    />
  ),
);

ConditionTextField.displayName = 'ConditionTextField';
